import React from "react";
import { useSelector } from "react-redux";
import { Box } from "@mui/material";
import CardItem from "./CardItem"; // Import the CardItem component
import image1 from "../../assets/fritolay.jpg";
import image2 from "../../assets/gsat.jpg";
import image3 from "../../assets/agrohub.jpg";

// Array of card data
const cardData = [
  {
    image: image1,
    title: "Fritolay Agriculture",
    appName: "FLAG",
    appUrl: `${process.env.REACT_APP_FLAG_REDIRECT_URL}`,
  },
  {
    image: image2,
    title: "Global Seed Planning Tool",
    appName: "GSPT",
    appUrl: `${process.env.REACT_APP_GSPT_REDIRECT_URL}`,
  },
  {
    image: image3,
    title: "PFNA Grower's Hub",
    appName: "PFNA",
  },
];

export default function Cards() {
  const token = JSON.parse(localStorage.getItem("okta-token-storage"));
  const user = useSelector((state) => state.user);
  const appNameList = [];
  user?.applications?.filter((item) => appNameList.push(item?.appName));
  console.log("application from appNameList", appNameList);
  const appList = cardData?.filter((item) => {
    return appNameList?.includes(item?.appName);
  });
  console.log("application from appNameList", user, appList, appNameList);
  return (
    <Box
      sx={{
        width: "100%",
        display: "flex",
        flexDirection: "row",
        gap: "16px",
        flexWrap: "wrap", // Allow cards to wrap on smaller screens
        alignItems: "flex-start",
        justifyContent: "center",
        borderRadius: "16px",
        padding: "16px", // Padding around the container
      }}
    >
      {appList?.map((item, index) => (
        <CardItem
          key={index}
          image={item.image}
          title={item.title}
          appName={item.appName}
          appUrl={item.appUrl}
          token={token}
        />
      ))}
    </Box>
  );
}
